export default __webpack_public_path__ + "static/lgbtq-belmond-5-7e5f149ddfaa85f19e0ec99f2a5f98e8.jpg";